import * as types from './mutation-types'
import {
  getSchedulesQuery,
  getStoreActiveEmployees,
  getAllPositions,
  getAllEmployees,
  getAllDepartments
} from './queries.graphql'

import gqlClient from '@/modules/graphql'
import api from '@/modules/api'


const actions = {
  async getSchedules({
    commit
  }, variables = {}) {
    
    if(!variables.storeId){
      return []
    }

    try {
      commit(types.GET_SCHEDULES_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getSchedulesQuery,
        variables : variables
      })
      commit(types.GET_SCHEDULES_SUCCESS, store)
    } catch (e) {
      commit(types.GET_SCHEDULES_ERROR, e)
    }
  },

  async getEmployeesFilterData({
    commit
  }, variables = {}) {
    if(!variables.storeId){
      return []
    }
    
    try {
      commit(types.GET_EMPLOYEES_FILTER_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getAllEmployees,
        variables : variables
      })
      commit(types.GET_EMPLOYEES_FILTER_SUCCESS, store)
    } catch (e) {
      commit(types.GET_EMPLOYEES_FILTER_ERROR, e)
    }
  },

  async getPositionsFilterData({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_POSITION_FILTER_BEGIN)
      const {
        data: {
          data: {
            company
          }
        }
      } = await gqlClient.query({
        query     : getAllPositions,
        variables : variables
      })
      commit(types.GET_POSITION_FILTER_SUCCESS, company)
    } catch (e) {
      commit(types.GET_POSITION_FILTER_ERROR, e)
    }
  },

  async getDepartmentsFilterData({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_DEPARTMENT_FILTER_BEGIN)
      const {
        data: {
          data: {
            company
          }
        }
      } = await gqlClient.query({
        query     : getAllDepartments,
        variables : variables
      })
      commit(types.GET_DEPARTMENT_FILTER_SUCCESS, company)
    } catch (e) {
      commit(types.GET_DEPARTMENT_FILTER_ERROR, e)
    }
  },

  async getStoreActiveEmployees({
    commit,
    rootState
  }) {
    if(!rootState.app.Store.id){
      return []
    }

    try {
      commit(types.GET_STORE_ACTIVE_EMPLOYEES_BEGIN)
      const {
        data: {
          data: {
            store: {
              employees
            }
          }
        }
      } = await gqlClient.query({
        query     : getStoreActiveEmployees,
        variables : {
          employeeCondition : {
            isActive : 1
          },
          storeId : rootState.app.Store.id
        }
      })

      commit(types.GET_STORE_ACTIVE_EMPLOYEES_SUCCESS, employees)
    } catch (e) {
      commit(types.GET_STORE_ACTIVE_EMPLOYEES_FAILED, e)
    }
  },

  updateFilter({
    commit
  }, pagination) {
    commit(types.UPDATE_FILTER, pagination)
  },

  async sendEmailWeeklyWorkSchedulesToEmployees({
    commit,
    rootState
  }, data) {
    try {
      commit(types.SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN)
      const {
        data: {
          message
        }
      } = await api.scheduling.sendEmailWeeklyWorkSchedulesToEmployees({
        ...data,
        storeId : rootState.app.Store.id
      })

      commit(types
        .SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS, message)
    } catch (e) {
      commit(types.SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED, e)
    }
  },

  async sendSmsWeeklyWorkSchedulesToEmployees({
    commit,
    rootState
  }, data) {
    try {
      commit(types.SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN)
      const {
        data: {
          message
        }
      } = await api.scheduling.sendSmsWeeklyWorkSchedulesToEmployees({
        ...data,
        storeId : rootState.app.Store.id
      })

      commit(types
        .SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS, message)
    } catch (e) {
      commit(types.SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED, e)
    }
  }

}

export default actions
